import { render, staticRenderFns } from "./Plastic Float.vue?vue&type=template&id=1f06ae4e&"
import script from "./Plastic Float.vue?vue&type=script&lang=js&"
export * from "./Plastic Float.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports